module.exports = __webpack_public_path__ + "img/hausaerztin.61532f11.svg";